import PropTypes from "prop-types";
import React, { Component } from "react";
import "./styles.scss";
import "react-table-v6/react-table.css";
import PropTypes from "prop-types";
import ReactTable from "react-table-v6";
import "react-table-v6/react-table.css";
import { Link } from "react-router-dom/es";
import moment from "moment";

import "./styles.scss";

const statusOptions = [null, "pending", "approved", "rejected"];

const customSortFunction = (rowA, rowB) => {
  const statusA = rowA.values.status;
  const statusB = rowB.values.status;

  // Replace 'pending' with the specific value you want to sort by
  if (statusA === "pending" && statusB !== "pending") {
    return -1;
  } else if (statusA !== "pending" && statusB === "pending") {
    return 1;
  }

  // If both statuses are the same or not 'pending', maintain the current order
  return 0;
};
class AssetListChecker extends Component {
  static defaultProps = {
    keyField: "id",
  };

  static propTypes = {
    keyField: PropTypes.string,
  };

  static propTypes = {
    assets: PropTypes.array.isRequired,
    columns: PropTypes.array.isRequired,
  };

  render() {
    const {
      showthumbnails,
      handleUpdateAsset,
      assets,
      isLoading,
      isDisabled,
    } = this.props;

    const defaultColumns = [
      {
        Header: () => (
          <div>
            {" "}
            <i className="fas fa-caret-down mr-1"></i> Name{" "}
          </div>
        ),
        headerStyle: {
          textAlign: "left",
          border: "1px solid transparent",
          "border-bottom-color": "grey",
        },
        accessor: "name",
      },
      {
        Header: () => (
          <div>
            {" "}
            <i className="fas fa-caret-down mr-1"></i> Uploaded by{" "}
          </div>
        ),
        headerStyle: {
          textAlign: "left",
          border: "1px solid transparent",
          "border-bottom-color": "grey",
        },
      },

      {
        Header: () => <div></div>,
        sortable: false,
        filterable: false,

        headerStyle: {
          textAlign: "left",
          border: "1px solid transparent",
          "border-bottom-color": "grey",
        },
      },
    ];

    const columns = [
      {
        Header: () => (
          <div>
            {" "}
            <i className="fas fa-caret-down mr-1"></i> Name{" "}
          </div>
        ),

        headerStyle: {
          textAlign: "left",
          border: "1px solid transparent",
          "border-bottom-color": "grey",
        },

        Cell: (props) => {
          return (
            <div className="flex flex-ai-c">
              <p className="mr-1">
                {props.original.status === "approved" && (
                  <i className="fas fa-circle-check status status-approved"></i>
                )}
                {props.original.status === "pending" && (
                  <i className="fas fa-clock-o status status-pending"></i>
                )}
                {props.original.status === "rejected" && (
                  <i className="fas fa-times-circle-o status status-rejected"></i>
                )}
                {props.original.status == null && (
                  <i className="fas fa-minus status-pending"></i>
                )}
              </p>
              <Link to={`/asset/${props.original.id}`}>
                <p>{props.original.name}</p>
              </Link>
            </div>
          );
        },

        style: {
          textAlign: "left",
          border: "1px solid transparent",
        },
      },
      {
        Header: () => <div></div>,
        accessor: "thumbnail",

        Cell: (props) => {
          return (
            <>
              {showthumbnails && (
                <div class="ml-3 preview item-preview image flex-container flex-direction-row">
                  <img src={props.original.thumbnail} alt="thumbnail" />
                </div>
              )}
            </>
          );
        },
      },

      {
        Header: () => (
          <div>
            {" "}
            <i className="fas fa-caret-down mr-1"></i> Uploaded by{" "}
          </div>
        ),
        headerStyle: {
          textAlign: "left",
          border: "1px solid transparent",
          "border-bottom-color": "grey",
        },
        accessor: "uploaded_by",

        style: {
          textAlign: "left",
          border: "1px solid transparent",
        },
      },

      {
        Header: () => <div className="d-flex align-items-end"></div>,
        sortable:false,
        filterable:false,

        headerStyle: {
          textAlign: "left",
          border: "1px solid transparent",
          "border-bottom-color": "grey",
        },
        style: {
          textAlign: "right",
          border: "1px solid transparent",
        },

        Cell: (props) => {
          return (
            <div class="d-flex align-items-center">
              <select
              disabled={isDisabled}
                onChange={(e) => {
                  handleUpdateAsset(
                    props.original.id,
                    props.original.type,
                    e.target.value
                  );
                }}
                style={{ width: "120px" }}
                value={props.original.status}
              >
                {statusOptions.map((status) => (
                  <option key={status} value={status}>
                    {status}
                  </option>
                ))}
              </select>
            </div>
          );
        },
      },


      {
        Header: () => (
          <div>
            {" "}
            <i className="fas fa-caret-down mr-1"></i> Date Uploaded{" "}
          </div>
        ),
        headerStyle: {
          textAlign: "left",
          border: "1px solid transparent",
          "border-bottom-color": "grey",
        },
        accessor: "created",

        Cell: (props) => {
          return <p>{moment(props.original.created).format("MMMM Do YYYY")}</p>;
        },

        style: {
          textAlign: "left",
          border: "1px solid transparent",
        },
      },
    ];

    const mobileColumns = [
      {
        Header: () => (
          <div>
            {" "}
            <i className="fas fa-caret-down mr-1"></i> Name{" "}
          </div>
        ),
        headerStyle: {
          textAlign: "left",
          border: "1px solid transparent",
          "border-bottom-color": "grey",
        },
        Cell: (props) => {
          return (
            <div className="flex flex-ai-c">
              <p className="mr-1">
                {props.original.status === "approved" && (
                  <i className="fas fa-circle-check status status-approved"></i>
                )}
                {props.original.status === "pending" && (
                  <i className="fas fa-clock-o status status-pending"></i>
                )}
                {props.original.status === "rejected" && (
                  <i className="fas fa-times-circle-o status status-rejected"></i>
                )}
                {props.original.status == null && (
                  <i className="fas fa-minus status-pending"></i>
                )}
              </p>
              <Link to={`/asset/${props.original.id}`}>
                <p>{props.original.name}</p>
              </Link>
            </div>
          );
        },

        style: {
          textAlign: "left",
          border: "1px solid transparent",
        },
      },
      {
        Header: () => (
          <div>
            {" "}
            <i className="fas fa-caret-down mr-1"></i> Uploaded by{" "}
          </div>
        ),
        headerStyle: {
          textAlign: "left",
          border: "1px solid transparent",
          "border-bottom-color": "grey",
        },
        accessor: "uploaded_by",

        style: {
          textAlign: "center",
          border: "1px solid transparent",
        },
      },
      {
        Header: () => <div className="d-flex align-items-end"></div>,
        sortable:false,
        filterable:false,

        headerStyle: {
          textAlign: "left",
          border: "1px solid transparent",
          "border-bottom-color": "grey",
        },
        style: {
          textAlign: "right",
          border: "1px solid transparent",
        },

        Cell: (props) => {
          return (
            <div class="d-flex align-items-center">
              <select
              disabled={isDisabled}
                onChange={(e) => {
                  handleUpdateAsset(
                    props.original.id,
                    props.original.type,
                    e.target.value
                  );
                }}
                style={{ width: "120px" }}
                value={props.original.status}
              >
                {statusOptions.map((status) => (
                  <option key={status} value={status}>
                    {status}
                  </option>
                ))}
              </select>
            </div>
          );
        },
      },

    ];

    return (
      <React.Fragment>
        {assets && assets.length === 0 ? (
          <ReactTable
            columns={defaultColumns}
            defaultPageSize={3}
            noDataText={"Loading Assets .."}
            loading={isLoading}
            showPagination={false}
          />
        ) : (
          <div>
            <div className="hide-for-desktop">
              <ReactTable
                columns={mobileColumns}
                data={assets}
                defaultPageSize={10}
                noDataText={"Loading Assets .."}
                loading={isLoading}
                defaultSorted={[
                  { id: "status", desc: false, sortBy: customSortFunction },
                ]}
              />
            </div>

            <div className="hide-for-mobile">
              <ReactTable
                columns={columns}
                data={assets}
                defaultPageSize={10}
                noDataText={"Loading Assets .."}
                loading={isLoading}
                defaultSorted={[
                  { id: "status", desc: false, sortBy: customSortFunction },
                ]}
              />
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

AssetListChecker.propTypes = {
  assets: PropTypes.array.isRequired,
 
};

export default AssetListChecker;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/AssetsListChecker/index.js